/**
 * The page `GET /v1/feeds/:feedId/activities` really sends: Stream's
 * `{ results, next, duration }` under `data`.
 *
 * `GetFeedActivitiesResponseSchema` (./activities) does not describe this wire
 * shape (it puts the activities directly in `data`), so web and mobile read it
 * through this envelope instead. The envelope is validated; each activity is
 * typed as `ExtendedFeedActivity` but passed through unvalidated, because the
 * enriched Stream activity carries more than that schema lists and validating
 * it would strip the fields the feed card renders.
 */

import { z } from 'zod'
import type { ExtendedFeedActivity } from './common'

const isRecord = (value: unknown): boolean => typeof value === 'object' && value !== null

export const FeedActivitiesPageResponseSchema = z.object({
  message: z.string().optional(),
  data: z.object({
    results: z.array(z.custom<ExtendedFeedActivity>(isRecord)),
    next: z.string().nullable().optional(),
    duration: z.string().optional()
  })
})

export type FeedActivitiesPageResponse = z.infer<typeof FeedActivitiesPageResponseSchema>
